import React from 'react';

export const ColourRichContent = () => {
  const baseImageUrl =
    'https://static.lenskart.com/owndays/img/contact-lens-pdp/rich-content/colour';

  return (
    <div className="contact-lens-rich-content__wrapper">
      <div className="contact-lens-rich-content__header__container">
        <h1 className="contact-lens-rich-content__header__logo">
          <span>OWNDAYS | COLOUR</span>
          <img alt="OWNDAYS | COLOUR" src={`${baseImageUrl}/logo.svg`} />
        </h1>

        <div>
          <h2 className="contact-lens-rich-content__header__title">
            Everyday lenses,
            <br />
            Elevated with ClearVision
          </h2>

          <p className="contact-lens-rich-content__header__description">
            Taurus Brown is a two-tone masterpiece, combining a cooler brown base with rich caramel
            brown overtones.
          </p>
        </div>
      </div>

      <div className="contact-lens-rich-content__main-preview">
        <picture>
          <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/main-preview_pc.webp`} />
          <img alt="OWNDAYS | COLOUR" src={`${baseImageUrl}/main-preview_sp.webp`} />
        </picture>

        <div>
          <div className="contact-lens-rich-content__main-preview__product">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>UV Shield</h3>
                <p>
                  99% UV blocking,
                  <br />
                  crystal‑clear view
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-1_pc.webp`} />
              <img alt="OWNDAYS | COLOUR" src={`${baseImageUrl}/product-1_sp.webp`} />
            </picture>
          </div>

          <div className="contact-lens-rich-content__main-preview__product" data-is-reverse="true">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>HydraTouch</h3>
                <p>
                  Hyaluronic acid
                  <br />
                  for all day comfort
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-2_pc.webp`} />
              <img alt="OWNDAYS | COLOUR" src={`${baseImageUrl}/product-2_sp.webp`} />
            </picture>
          </div>
        </div>
      </div>

      <div className="contact-lens-rich-content__main-preview">
        <picture>
          <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/main-product_pc.webp`} />
          <img alt="OWNDAYS | COLOUR" src={`${baseImageUrl}/main-product_sp.webp`} />
        </picture>

        <div>
          <div className="contact-lens-rich-content__main-preview__product">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>AquaFlow</h3>
                <p>
                  58% water for
                  <br />
                  superior oxygen flow
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-3_pc.webp`} />
              <img alt="OWNDAYS | COLOUR" src={`${baseImageUrl}/product-3_sp.webp`} />
            </picture>
          </div>

          <div className="contact-lens-rich-content__main-preview__product" data-is-reverse="true">
            <div className="contact-lens-rich-content__main-preview__product__title">
              <div>
                <h3>FeatherThin</h3>
                <p>
                  Precision thin profile for
                  <br />
                  effortless wear
                </p>
              </div>
            </div>

            <picture>
              <source media="(min-width: 1200px)" srcSet={`${baseImageUrl}/product-4_pc.webp`} />
              <img alt="OWNDAYS | COLOUR" src={`${baseImageUrl}/product-4_sp.webp`} />
            </picture>
          </div>
        </div>
      </div>
    </div>
  );
};
